import AppSplashPage from 'containers/AppSplashPage';

function LoginPage() {
  return <AppSplashPage />;
}

export default LoginPage;
